import type { Translations } from '../../types'

const featureFlagsMessages: Translations = {
  "featureFlags.header.eyebrow": "Sicurezza runtime",
  "featureFlags.header.title": "Feature Flags",
  "featureFlags.header.subtitle": "Gestisci rollout e attivazioni progressive per ambiente.",
  "featureFlags.auth.subtitle": "Sessione non valida",
  "featureFlags.auth.message": "Accedi come amministratore per gestire i feature flag.",
  "featureFlags.environment.dev": "Dev",
  "featureFlags.environment.prod": "Prod",
  "featureFlags.actions.create": "Crea feature flag",
  "featureFlags.actions.edit": "Modifica",
  "featureFlags.actions.enable": "Attiva",
  "featureFlags.actions.disable": "Disattiva",
  "featureFlags.actions.toggling": "...",
  "featureFlags.status.enabled": "Attivo",
  "featureFlags.status.disabled": "Disattivo",
  "featureFlags.loading": "Caricamento feature flag...",
  "featureFlags.empty.title": "Nessun feature flag disponibile",
  "featureFlags.empty.subtitle": "Crea il primo flag per iniziare a gestire rollout e audience.",
  "featureFlags.feedback.loadError": "Impossibile caricare i feature flag",
  "featureFlags.feedback.saved": "Feature flag salvato con successo",
  "featureFlags.feedback.saveError": "Impossibile salvare il feature flag",
  "featureFlags.feedback.toggled": "Stato feature flag aggiornato",
  "featureFlags.feedback.toggleError": "Impossibile aggiornare lo stato del feature flag",
  "featureFlags.table.key": "Key",
  "featureFlags.table.description": "Descrizione",
  "featureFlags.table.status": "Stato",
  "featureFlags.table.rollout": "Rollout",
  "featureFlags.table.environment": "Ambiente",
  "featureFlags.table.updatedAt": "Aggiornato",
  "featureFlags.table.actions": "Azioni",
  "featureFlags.stats.total": "Totali",
  "featureFlags.stats.enabled": "Attivi",
  "featureFlags.modal.createTitle": "Crea feature flag",
  "featureFlags.modal.editTitle": "Modifica feature flag",
  "featureFlags.modal.subtitle": "Configura attivazione, rollout e allowlist.",
  "featureFlags.modal.actions.cancel": "Annulla",
  "featureFlags.modal.actions.save": "Salva",
  "featureFlags.modal.actions.saving": "Salvataggio...",
  "featureFlags.modal.validation.keyRequired": "La key è obbligatoria",
  "featureFlags.modal.validation.descriptionRequired": "La descrizione è obbligatoria",
  "featureFlags.modal.validation.rolloutRange": "Il rollout deve essere compreso tra 0 e 100",
  "featureFlags.fields.key": "Key",
  "featureFlags.fields.description": "Descrizione",
  "featureFlags.fields.descriptionPlaceholder": "Descrivi obiettivo e ambito del flag",
  "featureFlags.fields.enabled": "Flag attivo",
  "featureFlags.fields.rolloutPercentage": "Rollout %",
  "featureFlags.fields.environment": "Ambiente",
  "featureFlags.fields.userAllowlist": "User allowlist",
  "featureFlags.fields.userAllowlistPlaceholder": "user-1, user-2",
  "featureFlags.fields.roleAllowlist": "Role allowlist",
  "featureFlags.fields.roleAllowlistPlaceholder": "admin, beta-tester"
}

export default featureFlagsMessages
